import React, { useState, useContext, } from 'react';
import { Form, Space, Input } from 'antd';
import { DeviceButtonGroup } from '../DeviceButtonGroup.component';
import { DeleteDeviceModal } from '../../../Modals/DeleteDeviceModal.component.';
import { Status } from '../../Status/Status.component';
import { DeleteDeviceButton } from '../DeleteDeviceButton.component';
import { GroupedDevicesTable, SerialNumCell } from '../GroupedDevicesTable.component';
import { PermissionsContext } from '../../../../../router/DashboardRoutes';
import { DeviceRestrictedInput } from '../DeviceRestrictedInput.component';

export const AwaitingCheckin = ({ data, isPanelPending, saveChanges, renderEditableCellValue, ...props}) => {

    const userPermissions = useContext(PermissionsContext);

    const [displayDeleteDevice, setDisplayDeleteDevice] = useState({display: false, item: ''});
    const [currentDevice, setCurrentDevice] = useState();

    const deleteDevice = (item) => {
        setDisplayDeleteDevice({display: true, title: item.deviceType, item: item});
    }

    const columns = [
        {
            title: 'Serial Number',
            dataIndex: 'serialNum',
            key: 'serialNum',
            width: 150,
            render: (value, record) => {
                return (
                    <SerialNumCell panelPending={isPanelPending(record)} value={value}/>
                )
            }
        },
        {
            title: 'Device Type', 
            dataIndex: 'deviceType', 
            key: 'deviceType',
            ellipsis: true,
            render: (value) => {
                return value?.toUpperCase();
            }
        },
        {
            title: 'Description',
            dataIndex: 'comment',
            key: 'comment',
            editable: true,
            ellipsis: true,
            render: (value, record) => renderEditableCellValue(value, record, 'comment')
        },
        {
            title: 'VPN Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            width: 120,
            ellipsis: true,
            render: (status) => {
                return <Status status={status}/>
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            ellipsis: true,
            render: (_, record) => {
                return (
                    <>
                        <Space size='small' onClick={(e) => e.stopPropagation()}>
                            <DeviceButtonGroup serialNum={record.serialNum} status={record.status} ant winbox/>
                            <DeleteDeviceButton pending={isPanelPending(record)} onClick={() => deleteDevice(record)} />
                        </Space>
                    </>
                )
            },
        },
    ];

    const formItems = (
        <>
            <DeviceRestrictedInput label='Description:' name='comment'>
                <Input/>
            </DeviceRestrictedInput>
        </>
    );

    return (
        <>
            <GroupedDevicesTable
                columns={columns}
                dataSource={data}
                formItems={formItems}
                isPanelPending={isPanelPending}
                saveChanges={saveChanges}
                currentDevice={currentDevice}
                setCurrentDevice={setCurrentDevice}
            />

            { displayDeleteDevice.display && 
                <DeleteDeviceModal 
                    title={displayDeleteDevice.title} 
                    item={displayDeleteDevice.item} 
                    visible={displayDeleteDevice.display} 
                    setVisible={setDisplayDeleteDevice}
                />
            }
        </>
    );
}